import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/CartContext";
import { CustomerAuthProvider } from "@/lib/CustomerAuthContext";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import SuccessPage from "@/pages/SuccessPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminPage from "@/pages/AdminPage";
import AdminResetPage from "@/pages/AdminResetPage";
import ComingSoonPage from "@/pages/ComingSoonPage";
import ReviewsPage from "@/pages/ReviewsPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import AccountPage from "@/pages/AccountPage";
import SaleBanner from "@/components/SaleBanner";
import { useAnalyticsTracker } from "@/lib/analytics";

function AnalyticsBridge() {
  useAnalyticsTracker();
  return null;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/coming-soon" element={<ComingSoonPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/shop/:slug" element={<ProductDetailPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/checkout/success" element={<SuccessPage />} />
      <Route path="/track" element={<TrackOrderPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/reset" element={<AdminResetPage />} />
      <Route path="/admin/*" element={<AdminPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <CustomerAuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AnalyticsBridge />
            <SaleBanner />
            <AppRouter />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "#09090b",
                  border: "2px solid #27272a",
                  color: "#fafafa",
                  borderRadius: 0,
                  fontFamily: "JetBrains Mono, monospace",
                  fontSize: 12,
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                },
              }}
            />
          </BrowserRouter>
        </CartProvider>
      </CustomerAuthProvider>
    </div>
  );
}

export default App;
